export const displayElement = (element: HTMLElement, show: boolean) => {
  if (element && element instanceof Element) {
    element.setAttribute('data-hidden', show ? 'false' : 'true');
  } else {
    console.error('Invalid element or element not found.');
  }
};
